import React, { useState, useEffect } from 'react';
import appLS from '../../../../constants/local-storage';
import getAssets from '../../../../image-loader';

function EmptyResults() {

  // const [logo, setLogo] = useState();
  const [notfoundno, setNoImg] = useState();
  const [notfounden, setEnImg] = useState();

  useEffect(() => {
    (async function getFiles() {
      if (!notfoundno) {
        setNoImg(await (await getAssets()).nosearchresultno.default);
      }
    })();
  }, [notfoundno])

  useEffect(() => {
    (async function getFiles() {
      if (!notfounden) {
        setEnImg(await (await getAssets()).nosearchresulten.default);
      }
    })();
  }, [notfounden])

  return (
    <section className='results-not-found'>
      <figure>
        {
          localStorage.getItem(appLS.appLanguage) === 'no' ?
            <img src={notfounden} alt='not-found' /> :
            <img src={notfoundno} alt='not-found' />
        }
      </figure>
    </section>
  );
}

export default EmptyResults;
